import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldConfig } from '../../model/admin';
import { CommonModule } from '@angular/common';
import { InputTextComponent } from '../input-text/input-text.component';
import { InputSelectComponent } from '../input-select/input-select.component';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';

@Component({
  selector: 'app-modal-form',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextComponent,
    InputSelectComponent,
    LoadingButtonComponent,
  ],
  templateUrl: './modal-form.component.html',
  styles: ``,
})
export class ModalFormComponent {
  @Input() title!: string;
  @Input() form!: FormGroup;
  @Input() loading = false;
  @Input() fields!: FormFieldConfig[];
  @Input() submitText = 'Guardar';

  @Output() formSubmit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
